import React from "react";
import { Check } from "@phosphor-icons/react";

const STEPS = ["Open", "In-Progress", "Resolved", "Closed"];

export default function StatusStepper({ status }) {
  const currentIdx = STEPS.indexOf(status);
  return (
    <div className="flex items-center w-full" data-testid="status-stepper">
      {STEPS.map((s, i) => {
        const isDone = i < currentIdx;
        const isCurrent = i === currentIdx;
        const isUpcoming = i > currentIdx;
        return (
          <React.Fragment key={s}>
            <div className="flex flex-col items-center gap-1.5 shrink-0">
              <div
                className={`w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-semibold transition-all duration-300 ${
                  isDone
                    ? "bg-emerald-600 text-white"
                    : isCurrent
                    ? "bg-[#0B2A5B] text-white ring-4 ring-blue-100 scale-110"
                    : "bg-slate-100 text-slate-400 border border-slate-200"
                }`}
              >
                {isDone ? <Check size={13} weight="bold" /> : i + 1}
              </div>
              <div
                className={`text-[10px] uppercase tracking-wider font-semibold whitespace-nowrap ${
                  isCurrent
                    ? "text-[#0B2A5B]"
                    : isDone
                    ? "text-emerald-700"
                    : "text-slate-400"
                }`}
              >
                {s}
              </div>
            </div>
            {i < STEPS.length - 1 && (
              <div className="flex-1 h-0.5 mx-2 -mt-5 relative">
                <div className="absolute inset-0 bg-slate-200 rounded" />
                <div
                  className={`absolute inset-0 rounded transition-all duration-500 ${
                    i < currentIdx ? "bg-emerald-500" : "bg-transparent"
                  }`}
                  style={{ width: i < currentIdx ? "100%" : "0" }}
                />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
